<template>
	<div class="big__slider">
		<!-- v-if="window.width > 1366" -->
		<div class="swiper-container big-swiper">
			<div class="swiper-wrapper">
				<div
					class="swiper-slide"
					v-for="(slide, index) in JSON.parse(slides)"
					:key="index"
					:style="{
						backgroundColor: slide.background_color,
						backgroundImage: 'url(' + slide.background_image + ')',
					}"
				>
					<div class="slide-content">
						<img :src="play_icon" alt="play" class="play__button" />
						<h4 v-html="slide.category"></h4>
						<h1 v-html="slide.title"></h1>
						<a
							:href="slide.link"
							:class="[slide.link_color, slide.link_size]"
							v-html="slide.link_label"
						></a>
					</div>
				</div>
			</div>

			<div class="swiper-nav">
				<div class="swiper-button-prev-testimonial">
					<img :src="prev_icon" alt="play" />
				</div>
				<div class="swiper-button-next-testimonial">
					<img :src="next_icon" alt="play" />
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import Swiper, { Navigation, Pagination, Autoplay } from 'swiper';
import 'swiper/swiper-bundle.css';
Swiper.use([Navigation, Pagination, Autoplay]);

export default {
	data() {
		return {
			bigSlider: null,
			window: {
				width: 0,
				height: 0,
			},
		};
	},

	props: {
		slides: {},
		title: {},
		play_icon: {},
		next_icon: {},
		prev_icon: {},
	},

	computed: {},

	watch: {},

	methods: {
		handleResize() {
			this.window.width = window.innerWidth;
			this.window.height = window.innerHeight;
		},
	},

	components: {},

	created() {
		window.addEventListener('resize', this.handleResize);
		this.handleResize();
	},
	destroyed() {
		window.removeEventListener('resize', this.handleResize);
	},
	mounted() {
		// eslint-disable-next-line no-unused-vars
		this.bigSlider = new Swiper('.swiper-container', {
			// Optional parameters
			speed: 400,
			direction: 'horizontal',
			loop: false,
			autoHeight: false,
			autoplay: {
				delay: 3000,
			},
			// Navigation arrows
			navigation: {
				nextEl: '.swiper-button-next-testimonial',
				prevEl: '.swiper-button-prev-testimonial',
			},
		});
	},
};
</script>

<style lang="scss" scoped>
@import '../../styles/common/variables';

/* write SCSS here */

.big__slider {
	background: $edc-charcoal;
}

.swiper-container {
	width: 100%;
	position: relative;

	.swiper-wrapper {
		height: 70vh ;

		@media (max-width: 1366px) {
			height: 450px;
		}

		.swiper-slide {
			height: 70vh;
			display: grid;
			grid-template-columns: repeat(12, 1fr);
			column-gap: 0;
			background-size: cover;
			background-repeat: no-repeat;
			background-position: center center;

			@media (max-width: 1366px) {
				height: 450px;
			}

			.slide-content {
				grid-column: 3 / span 8;
				display: flex;
				align-items: flex-start;
				justify-content: center;
				flex-direction: column;

				@media (max-width: 1366px) {
					grid-column: 2 / span 10;
					padding: 50px 0;
				}

				img {
					width: 40px;
				}

				h4 {
					color: #2e4a53;
					margin: 20px 0;
				}

				h1 {
					font-size: 4rem;
					color: white;
					max-width: 80%;

					@media (max-width: 1366px) {
						font-size: 2rem;
						max-width: 100%;
					}
				}

				a {
					font-size: 4rem;
					font-weight: bold;
					text-decoration: none;

					@media (max-width: 1366px) {
						font-size: 2rem;
					}

					&.black {
						color: black;
					}

					&.red {
						color: $edc-red;
					}

					&.small {
						font-size: 1rem;
						margin-top: 50px;
					}
				}
			}
		}
	}
}

.swiper-nav {
	position: absolute;
	z-index: 100;
	top: 50%;
	transform: translateY(-50%);
	width: calc(100% - 50px);
	display: flex;
	justify-content: space-between;

	@media (max-width: 1366px) {
		display: none;
	}

	.swiper-button-prev-testimonial,
	.swiper-button-next-testimonial {
		display: flex;
		margin-left: 50px;

		img {
			height: 40px;
		}
	}
}
</style>





// WEBPACK FOOTER //
// resources/assets/scripts/vue/BigSlider.vue